import { Box, Button, Heading } from '@chakra-ui/react'
import { useEffect, useMemo, useState } from 'react'

import { FormField } from '../../../components/FormField'
import { MoneyInput } from '../../../components/MaskedInput'
import { formatCurrencyValue, useAppToast } from '../../../helpers'
import { IUpdateValuePayload } from '../../../services/Refunds/interfaces'
import RefundsService from '../../../services/Refunds/RefundsService'

/**
 * O valor do reembolso é guardado e enviado como a string formatada (`'R$ 1.234,50'`) — daí a
 * ponte entre o número do `<MoneyInput>` e o texto do payload.
 */
const refundValueToNumber = (value: string): number | null => {
  const digits = value.replace(/\D/g, '')
  return digits === '' ? null : Number(digits) / 100
}

interface IRefundsEditValueModalProps {
  fetchRefunds: () => void
  onClose: () => void
  refundId: number
  refundValue: string
}

export default function RefundsEditValueModal({
  fetchRefunds,
  onClose,
  refundId,
  refundValue
}: IRefundsEditValueModalProps) {
  const refundsService = useMemo(() => new RefundsService(), [])
  const toast = useAppToast()
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState<IUpdateValuePayload>({
    value: refundValue
  })

  const handleSubmit = async () => {
    setSaving(true)

    if (!form.value) {
      toast.warning('Insira um valor')
      setSaving(false)
      return
    }

    try {
      await refundsService.updateValue(refundId, form)
      toast.success('Valor atualizado com sucesso!')
      fetchRefunds()
      onClose()
    } catch {
      toast.error('Erro ao atualizar valor!')
    } finally {
      setSaving(false)
    }
  }

  useEffect(() => {
    setForm({
      value: refundValue
    })
  }, [])

  return (
    <>
      <Heading as="h2" mb="4">
        Editar valor do reembolso
      </Heading>
      <Box>
        <FormField label="Valor Total da Despesa" isRequired={true} mb="4">
          <MoneyInput
            value={refundValueToNumber(form.value)}
            onChange={(value) => setForm({ ...form, value: value == null ? '' : `R$ ${formatCurrencyValue(value)}` })}
          />
        </FormField>
      </Box>

      <Box display={'flex'} justifyContent={'space-between'}>
        <Button colorScheme="magenta" disabled={saving} onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button colorScheme="magenta" disabled={saving} onClick={handleSubmit}>
          Salvar
        </Button>
      </Box>
    </>
  )
}
